import TableCell from '@material-ui/core/TableCell'
import React from 'react'

export const timeCut = (
    text: string,
    id: any,
    index: number,
    VisitData: any,
    VisitDataDel: any,
    Store: any,
    tableBodyPositionElement: any
) => {
    let newText = text.split(' ')[1]

    if (newText === '' || newText === null) text = '00:00:00'
    return (
        <>
            <TableCell
                style={{ textAlign: tableBodyPositionElement }}
                key={'td' + id + '_' + index}
                data-param={VisitData}
                data-param-del={VisitDataDel}
                data-id={id}
                id={'td' + id + '_' + index}
            >
                {newText}
            </TableCell>
        </>
    )
}
